import { EmailStatusEnumType } from '__generated__/graphql';

export const emailStatusToReadable = (
  status: EmailStatusEnumType
): { label: string; color: string } => {
  switch (status) {
    case EmailStatusEnumType.Unknown:
      return {
        label: 'Unknown',
        color: 'gray',
      };
    case EmailStatusEnumType.Sent:
      return {
        label: 'Recived',
        color: 'blue',
      };
    case EmailStatusEnumType.Delivered:
      return {
        label: 'Received',
        color: 'green',
      };
    case EmailStatusEnumType.Opened:
      return {
        label: 'Opened',
        color: 'purple',
      };
    case EmailStatusEnumType.Clicked:
      return {
        label: 'Clicked',
        color: 'indigo',
      };
    default:
      return {
        label: 'Unknown',
        color: 'gray',
      };
  }
};
